<script>
import Vue from 'vue';
import {mapState, mapActions, mapGetters} from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState({
            user: state => state.auth.user,
            contract: state => state.contract.contract
        }),
        ...mapGetters({
            contractProgressObject: 'contract/contractProgressObject',
            emailReadyForSupplierSent: 'contract/emailReadyForSupplierSent'
        })
    },
    methods: {
        ...mapActions({
            contractManagementSendEmailSupplier: 'contract/contractManagementSendEmailSupplier'
        })
    }
});
</script>
<template>
    <div class="contract-form-alert">
        <transition name="fade" mode="out-in">
            <div class="contract-form-alert__content">
                <span v-if="contract.error && !contract.productError" class="contract-form-alert__error">
                    {{ $t('contract.form.missingContract') }}
                </span>
                <span v-if="contract.error && contract.productError" class="contract-form-alert__error">
                    {{ $t('contract.form.unknownProduct') }}
                </span>
                <span v-if="contract.item && !contract.item.supplierExists" class="contract-form-alert__error">
                    {{ $t('contract.form.alert') }}
                </span>
            </div>
        </transition>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/ContractFormAlert/ContractFormAlert.vue